import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TeamsComponent } from './teams/teams.component';
import { TeamComponent } from './team/team.component';
import { DataModule } from '../data/data.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

import { GridModule } from '../grid/grid.module';
import { InputModule } from '../input/input.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TeamPlanComponent } from './team-plan/team-plan.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TeamService } from './team.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TeamDateComponent } from './team-date/team-date.component';
import { MatSelectModule } from '@angular/material/select';
import { AgGridModule } from 'ag-grid-angular';
import { NotificationModule } from '@notification/notification.module';
import { TeamDeleteDialogComponent } from './team-delete-dialog/team-delete-dialog.component';
import { TeamDeleteButtonComponent } from './team-delete-button/team-delete-button.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { GridCellModule } from '@grid-cell/grid-cell.module';

@NgModule({
  declarations: [
    TeamsComponent,
    TeamComponent,
    TeamPlanComponent,
    TeamDateComponent,
    TeamDeleteDialogComponent,
    TeamDeleteButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    AgGridModule,
    DataModule,
    GridModule,
    GridCellModule,
    InputModule,
    ToolbarModule,
    NotificationModule
  ],
  exports: [
    TeamsComponent,
    TeamComponent
  ],
  providers: [
    TeamService,
    //{provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
  ]
})
export class TeamsModule { }
